import * as React from 'react';
import {IDriver, IVehicle} from '../../../../../../data/api/models';
import {Col, ControlLabel, FormGroup, Row} from 'react-bootstrap';
import {Field, FieldArray} from 'redux-form';
import {
  isRequired,
  normalizeCurrency,
  normalizeYear,
  isNotShorterThan, isValidDob, minAge, maxAge, isValidDate,
} from '../../../../../../util/validators';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import * as moment from 'moment';
import SelectControl from '../../../../../../components/SelectControl';
import FaCheck from 'react-icons/fa/check';
import {get, isUndefined} from 'lodash';
import TitleField from '../../../../../../components/TitleField';
import AlternativeDatePicker from '../../../../../../components/AlternativeDatePicker';
import Claims from '../Claims';
import Convictions from '../Convictions';
import FaTrash from 'react-icons/fa/trash';

interface IDriverProps {
  index: number;
  driver: IDriver;
  name: string;
  dispatch: any;
  change: any;
  claimOptions: any;
  convictionOptions: any;
  convictionDescriptions: any;
  deleteDriver: any;
}

interface IDriverState {
  showLicenceDate: boolean;
}

class Driver extends React.Component<IDriverProps, IDriverState> {
  public state = {
    showLicenceDate: false,
  };

  public componentDidMount() {
    const { dispatch, change, driver, name } = this.props;

    switch (driver.typeOfLicence) {
      case 'Unknown':
        this.setState({ showLicenceDate: true });
        dispatch(change(name + '.licenceSelection', 'date'));
        break;
      case 'Provisional (UK) Car Licence':
        dispatch(change(name + '.licenceSelection', 'provisional'));
        break;
      case 'No Licence Held':
        dispatch(change(name + '.licenceSelection', 'none'));
        break;
    }
  }

  private handleDeleteDriver = (index) => (e) => {
    const { deleteDriver } = this.props;
    deleteDriver(index);
  }

  private updateLicenceSelection = (event) => {
    const { dispatch, change, name } = this.props;

    if (event.target.value === 'date') {
      this.setState({ showLicenceDate: true });
    } else {
      this.setState({ showLicenceDate: false });
      dispatch(change(name + '.lengthOfLicence', ''));
    }

    switch (event.target.value) {
      case 'date':
        dispatch(change(name + '.typeOfLicence', 'Unknown'));
        break;
      case 'provisional':
        dispatch(change(name + '.typeOfLicence', 'Provisional (UK) Car Licence'));
        break;
      case 'none':
        dispatch(change(name + '.typeOfLicence', 'No Licence Held'));
        break;
    }
  }

  private renderName() {
    const { name } = this.props;

    return (
      <>
        <FormGroup controlId={'customer'}>
          <div className="row-names">
            <div>
              <Col componentClass={ControlLabel} sm={6}>
                What is your name?
              </Col>
              <Col
                sm={3}
                style={{ paddingBottom: '9px' }}
                className="title-width"
              >
                <TitleField
                  name={name + '.title'}
                  validate={[ isRequired ]}
                  type="adult"
                />
              </Col>
            </div>
            <div className="row-names">
              <Col smOffset={6} sm={4} style={{ paddingBottom: '9px' }}>
                <Field
                  type="text"
                  placeholder="Forename"
                  name={name + '.firstName'}
                  component={FieldFormControl}
                  validate={[isRequired]}
                />
              </Col>
            </div>
            <div className="row-names">
              <Col smOffset={6} sm={4} style={{ paddingBottom: '9px' }}>
                <Field
                  type="text"
                  placeholder="Surname"
                  name={name + '.lastName'}
                  component={FieldFormControl}
                  validate={[isRequired]}
                />
              </Col>
            </div>
          </div>
        </FormGroup>
      </>
    );
  }

  private renderDateOfBirth() {
    const { name } = this.props;

    return (
      <FormGroup controlId="dob">
        <Col componentClass={ControlLabel} sm={6}>
          Date of birth
        </Col>
        <Col sm={6}>
          <div className="alternative-date-picker">
            <div className="field">
              <Field
                name={name + '.dob'}
                id={name + '-dob-text-field'}
                type="masked-date"
                placeholder="dd/mm/yyyy"
                component={FieldFormControl}
              />
            </div>
            <div className="icon">
              <Field
                name={name + '.dob'}
                maxDate={moment()}
                component={AlternativeDatePicker}
                validate={[
                  isRequired,
                  isValidDob,
                  minAge,
                  maxAge,
                ]}
              />
            </div>
          </div>
        </Col>
      </FormGroup>
    );
  }

  private renderLicence() {
    const { name, driver } = this.props;
    const { showLicenceDate } = this.state;

    return (
      <>
        <FormGroup controlId={'licence_type'} >
          <Col componentClass={ControlLabel} sm={6}>
            {driver.firstName} {driver.lastName} Date of passed test for the class of vehicle being insured
          </Col>
          <Col sm={6}>
            <Col sm={12}>
              {!showLicenceDate && (
                <Row className="button-group-container">
                  <Col sm={12} className="other-input">
                    <Field
                      name="licenceSelection"
                      type="radio"
                      value={'date'}
                      component={FieldFormControl}
                      onChange={this.updateLicenceSelection}
                      validate={[isRequired]}
                    >
                      <div className={'button-group-btn-alt'}>
                        <span />
                        Date
                      </div>
                    </Field>
                  </Col>
                </Row>
              )}
              {showLicenceDate && (
                <Row>
                  <Col sm={12}
                       className="button-group-btn-container input-alt vehicle-info-centre">

                    <div className="alternative-date-picker">
                      <div className="field">
                        <Field
                          name={name + '.lengthOfLicence'}
                          id={name + '-length-of-licence-text-field'}
                          type="masked-date"
                          placeholder="dd/mm/yyyy"
                          component={FieldFormControl}
                        />
                      </div>
                      <div className="icon">
                        <Field
                          name={name + '.lengthOfLicence'}
                          maxDate={moment()}
                          component={AlternativeDatePicker}
                          validate={[
                            isRequired,
                            isValidDate,
                          ]}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              )}
              <Row className="button-group-container">
                <Col sm={12} className="input-alt">
                  <Field
                    name="licenceSelection"
                    type="radio"
                    value={'provisional'}
                    onChange={this.updateLicenceSelection}
                    component={FieldFormControl}
                    validate={[isRequired]}
                  >
                    <div className={'button-group-btn-alt'}>
                      <span />
                      <div className="visible-lg-inline">No test passed -</div>&nbsp;Provisional licence held
                    </div>
                  </Field>
                </Col>
              </Row>
              <Row className="button-group-container">
                <Col sm={12} className="input-alt">
                  <Field
                    name="licenceSelection"
                    type="radio"
                    value={'none'}
                    component={FieldFormControl}
                    onChange={this.updateLicenceSelection}
                    validate={[isRequired]}
                  >
                    <div className={'button-group-btn-alt'}>
                      <span />
                      No valid driving licence held
                    </div>
                  </Field>
                </Col>
              </Row>
            </Col>
          </Col>
        </FormGroup>
      </>
    );
  }

  private renderClaims() {
    const { name, claimOptions, dispatch, change } = this.props;

    return (
      <>
        <FieldArray
          name={name + '.claims'}
          component={Claims}
          claimOptions={claimOptions}
          claimDataPath={name}
          dispatch={dispatch}
          change={change}
        />
      </>
    );
  }

  private renderConvictions() {
    const { name, convictionOptions, convictionDescriptions, dispatch, change } = this.props;

    return (
      <>
        <FieldArray
          name={name + '.convictions'}
          component={Convictions}
          convictionOptions={convictionOptions}
          convictionDescriptions={convictionDescriptions}
          convictionDataPath={name}
          dispatch={dispatch}
          change={change}
        />
      </>
    );
  }

  public render() {
    const { index, driver, dispatch, change } = this.props;

    if (driver.proposer) {
      return <div />;
    }

    return (
      <div className="sub-title">
        <Row>
          <Col sm={1}>
            <img src={require('../../../../img/driver.svg')} alt="" className="img-responsive padding-right" />
          </Col>
          <Col sm={10} className="vehicle-info-centre-subtitle">
            {driver.firstName ? (driver.firstName + ' ' + driver.lastName) : ('Driver' + (index + 1))}
          </Col>
          <Col sm={1}>
            <div
              className="pointer"
              onClick={this.handleDeleteDriver(index)}
            >
              <FaTrash />
            </div>
          </Col>
        </Row>
        {this.renderName()}
        {driver.lastName && (
          <>
            {this.renderDateOfBirth()}
          </>
        )}
        {driver.dob && (
          <>
            {this.renderLicence()}
          </>
        )}
        {driver.typeOfLicence && (
          <>
            {this.renderClaims()}
            {this.renderConvictions()}
          </>
        )}
      </div>
    );
  }
}

export default Driver;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Drivers/components/Driver/index.tsx